/**
 * Queries e Mutations GraphQL per DDTDaLista
 * 
 * Chiamate al server ghiaia3pkg/bolleview per operazioni Google Sheets
 */
import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

// Mutation per creare un nuovo spreadsheet template
const CREA_SPREADSHEET_DDT_LISTA = gql`
  mutation CreaSpreadsheetDdtLista {
    creaSpreadsheetDdtLista {
      url
      spreadsheetId
    }
  }
`;

// Mutation per elaborare uno spreadsheet esistente
const PROCESSA_SPREADSHEET_DDT_LISTA = gql`
  mutation ProcessaSpreadsheetDdtLista(
    $spreadsheetUrl: String!
    $nomeSheet: String
    $rigaIntestazione: Int
  ) {
    processaSpreadsheetDdtLista(
      spreadsheetUrl: $spreadsheetUrl
      nomeSheet: $nomeSheet
      rigaIntestazione: $rigaIntestazione
    ) {
      elaborate
      salvati
      errori
      saltate
      dettagli
    }
  }
`;

/**
 * Hook per creare un nuovo spreadsheet template DDT
 */
export function useCreaSpreadsheetDdtLista() {
    const [mutate, { loading, error }] = useMutation(CREA_SPREADSHEET_DDT_LISTA);

    const creaSpreadsheet = useCallback(async () => {
        try {
            const response = await mutate();
            return response.data?.creaSpreadsheetDdtLista;
        } catch (err) {
            console.error('Errore creazione spreadsheet:', err);
            throw err;
        }
    }, [mutate]);

    return { creaSpreadsheet, loading, error };
}

/**
 * Hook per elaborare uno spreadsheet DDT esistente
 */
export function useProcessaSpreadsheetDdtLista() {
    const [mutate, { loading, error }] = useMutation(PROCESSA_SPREADSHEET_DDT_LISTA);

    const processaSpreadsheet = useCallback(async (spreadsheetUrl, nomeSheet, rigaIntestazione) => {
        try {
            const response = await mutate({ 
                variables: { 
                    spreadsheetUrl,
                    nomeSheet: nomeSheet || undefined,
                    rigaIntestazione: rigaIntestazione || undefined
                } 
            });
            return response.data?.processaSpreadsheetDdtLista;
        } catch (err) {
            console.error('Errore elaborazione spreadsheet:', err);
            throw err;
        }
    }, [mutate]);

    return { processaSpreadsheet, loading, error };
}
